



















































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import ViewBudgetExecution from "@/components/porposal-detail-component/viewReport.vue";
@Component({
  components: {
    ViewBudgetExecution
  }
})
export default class ReportDetail extends Vue {
  
  goToTable() {
    this.$router.push('/recived-reports-fondocyt');
  }

}
